<template>
  <el-dialog
    append-to-body
    :visible.sync="visible"
    v-if="visible"
    width="80%"
    top="4vh"
    center
    class="Dialog"
    title="手工新增费用--选择订单指令"
  >
    <div class="dialog-content">
      <sirui-search
        ref="storeDataSearch"
        :query="query"
        :columns="searchFormColumns"
        @changeProductTypeHandler="changeProductTypeHandler"
        @changeCustomerNoMethod="changeCustomerNoMethod"
        @changeContractMethod="changeContractMethod"
        @resetBtnClick="resetBtnClickHandler"
        @searchBtnClick="queryBtnClickHandler"
      ></sirui-search>
      <div class="main-content">
        <sirui-table
          ref="siruiTable"
          height="300"
          :loading="load"
          :data="tableData"
          :paging="true"
          :setting="false"
          :showToolbar="false"
          :customVisible="false"
          :columns="columnList"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @handleSelectionChange="handleSelectionChange"
        >
          <vxe-table-column type="seq" width="50" title="序号"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <!-- <template v-slot="{ row }">
              <template v-if="item.field === 'settlementBusinessType'">{{
                row.settlementBusinessType
              }}</template>
              <template v-else-if="item.field === 'settlementStatus'">{{
                row.settlementStatus
              }}</template>
              
              <template v-else>{{ row[item.field] }}</template>
            </template> -->
          </vxe-table-column>
        </sirui-table>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" style="margin-top: 15px" @click="cancel">取消</el-button>
        <el-button type="primary" style="margin-top: 15px" @click="SelectInstructionHandler"
          >新增费用</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { searchColumns, defaultTableColumn } from './index.js';
  // , tableList
  import RECEIVABLES_MULTIMODALTRANSPORT from '@/api/receivablesAndPayables/multimodalTransport.js';
  import selectInstructionListMixin from './index.js';
  export default {
    mixins: [selectInstructionListMixin],
    props: {},
    data() {
      return {
        load: false,
        menuButtonList: [], // 表格功能按钮
        multipleSelection: [], // 表格被选中的行数据
        tableData: [], // 表格数据
        columnList: defaultTableColumn,
        query: {
          // settlementCompanyNo: '',
          // settlementDepartmentNo: '',
          // settlementStatus: '',
          customerNo: '',
          contractCode: '',
          // settlementType: '1',
          orderCode: '',
          instructCode: '',
          productType: '',
          orderServiceType: '',
          instructIssueEndDate: '',
          instructIssueStartDate: '',
          orderStatus: 'completed',
        },
        companyCode: null,
        visible: false,
      };
    },
    computed: {
      searchFormColumns() {
        return searchColumns(this);
      },
    },
    mounted() {
      // this.getTableData();
    },
    methods: {
      openDialog() {
        this.visible = true;
        this.getTableData();
      },
      // 切换客户
      changeCustomerNoMethod(val) {
        console.log(val, '修改客户');
        this.query.customerNo = val[0].partnerCode;
      },
      // 修改合同
      changeContractMethod(val) {
        this.query.contractCode = val[0].contractCode;
        console.log(val, '修改合同');
      },
      // 获取表格数据
      async getTableData(pageNum = 1, pageSize = 10) {
        const postData = {
          ...this.query,
          pageNum,
          pageSize,
        };
        console.log(postData, '搜索', pageNum, pageSize);
        const { data } = await this.$axios.post(
          RECEIVABLES_MULTIMODALTRANSPORT.ORDERINSTRUCT_QUERY_API,
          postData
        );
        console.log(data, 'ca555555555');
        this.tableData = data?.data?.list;
        this.$refs.siruiTable.setPageTotal(data?.data?.total);
      },
      // 表格选择行
      handleSelectionChange(row) {
        console.log(row);
        this.multipleSelection = row;
      },
      //确认新增
      SelectInstructionHandler() {
        console.log(this.multipleSelection, 'this.multipleSelection');
        if (this.multipleSelection.length) {
          this.$emit('SelectInstructionHandler', this.multipleSelection);
          this.cancel();
        } else {
          this.$message.error('请选择行操作！');
        }
      },
      cancel() {
        this.query = {
          customerNo: '',
          contractCode: '',
          orderCode: '',
          instructCode: '',
          productType: '',
          orderServiceType: '',
          instructIssueEndDate: '',
          instructIssueStartDate: '',
          orderStatus: 'completed',
        };
        this.visible = false;
      },
      // 搜索
      queryBtnClickHandler() {
        console.log('搜索', this.query);
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData(1, this.$refs.siruiTable.page.pageSize);
      },
      // 重置
      resetBtnClickHandler() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.serviceList = [];
        this.getTableData();
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData(1, this.$refs.siruiTable.page.pageSize);
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData(this.$refs.siruiTable.page.pageNum, this.$refs.siruiTable.page.pageSize);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    padding-bottom: 5px;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 25px;
      padding: 10px;
      border-bottom: 2px solid #ddd;
      margin-bottom: 10px;
      box-sizing: border-box;
    }
  }
  ::v-deep {
    .el-dialog__body {
      padding: 15px 20px !important;
    }
  }
</style>
